import Checkbox from '../../../ui/checkbox/checkbox'
import Cell from './../cell'
import dashbordStore from '../../../../store/dashbord'
import { observer } from 'mobx-react-lite'
import { Tooltip } from 'react-tooltip'
import ProductSetLabel from '../../../productSetLabel/ProductSetLabel'
import { PositionsTable } from './positionsTable'

function OrderDetail({
  data,
  getData,
  onSelectPosition,
  selectAllPositions,
  onPositionDetail,
  selectedPositionsStages,
  showOrderKitModal,
  orderIdDB
}) {
  const selectedLength = selectedPositionsStages.length

  return (
    <>
      <div className='product-table border border-Content/Border border-l-0 border-r-0 border-b-0'>
        <div className='flex'>
          <div>
            <div className='flex'>
              <Cell ml='ml-[0px]' width='w-[4.8rem]' height='h-[6rem]'>
                <Checkbox active={data.positions?.length === selectedLength} onChange={selectAllPositions}></Checkbox>
              </Cell>
              <Cell height='h-[6rem]' width='w-[10rem]'>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Фото</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]'>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Артикул</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]'>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Название товара</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]' width={'w-[15rem]'}>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Количество</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]' width={'w-[10rem]'}>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Количество коробок</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]' width={`w-[38rem]`}>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Метод печати</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]' width={'w-[9rem]'}>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Количество цветов</span>
                </div>
              </Cell>
              <Cell height='h-[6rem] w-[28rem]'>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Логотип</span>
                </div>
              </Cell>
              <Cell height='h-[6rem]'>
                <div className='flex flex-col gap-[0.8rem] text-center font-semibold'>
                  <span>Этап</span>
                </div>
              </Cell>
            </div>
            <PositionsTable
              data={data}
              getData={getData}
              showOrderKitModal={showOrderKitModal}
              orderIdDB={orderIdDB}
              onSelectPosition={onSelectPosition}
              onPositionDetail={onPositionDetail}
            />
            <Tooltip
              className='cell_tooltip'
              opacity='1'
              clickable={true}
              style={{
                backgroundColor: '#000000',
                padding: '12px',
                boxShadow: 'none',
                pointerEvents: 'auto',
                zIndex: 10,
                fontSize: '16px',
                maxWidth: '400px'
              }}
              id={'cell_tooltip'}></Tooltip>
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(OrderDetail)
